import { useState } from 'react';
import './index.css';
import { BsCreditCard } from 'react-icons/bs';
import { IoLayersOutline } from 'react-icons/io5';
import { IoRocketOutline } from 'react-icons/io5';

import { IoSpeedometerOutline } from 'react-icons/io5';
import { AiOutlineLineChart } from 'react-icons/ai';
import { GiTeacher } from 'react-icons/gi';


const data = [
  {
    inActive: 'All in One Solution',
    icon: (
      <IoLayersOutline
        size='30px'
        color='#FDC00B'
        style={{ cursor: 'pointer', alignSelf: 'center', height: '25%' }}
      />
    ),
    inActiveList: [
      'Process orders, control queues & manage inventory.',
      'No third-party companies',
    ],
    activeList: [
      'Manage and configure your venue from the back-office.',
      'One integrated system for customers, owners, managers and bartenders.',
    ],
    active: 'All in One Solution',
  },
  {
    inActive: 'Transaction Fees',
        icon: (
      <BsCreditCard
        size='26px'
        color='#FDC00B'
        style={{ cursor: 'pointer', alignSelf: 'center', height: '25%' }}
      />
    ),
    inActiveList: [
      'No subscription costs',
      'Simple and low fee structure',
    ],
    activeList: [
      'For in-venue orders we charge 1.75% per transaction and on Delivery orders we charge 5% per transaction.',
      'If you need a tablet or printer we can provide one free of charge.',
    ],
    active: 'Transaction Fees',
  },
  {
    inActive: 'Increased Orders and Effeciency',
        icon: (
      <IoRocketOutline
        size='26px'
        color='#FDC00B'
        style={{ cursor: 'pointer', alignSelf: 'center', height: '25%' }}
      />
    ),
    inActiveList: [
      'Generate more sales by easing the payment process',
      'Embracing technology smoothes your service',
    ],
    activeList: [
      'Ordering apps save venues time, money and generate more sales. They free up bartenders to focus on operations.',
      'Increase spend-per-head and volume of orders, reduce human errors and plan ahead to increase efficiency.',
    ],
    active: 'Increased Orders and Effeciency',
  },
  {
    inActive: 'Quick Setup',
        icon: (
      <IoSpeedometerOutline
        size='26px'
        color='#FDC00B'
        style={{ cursor: 'pointer', alignSelf: 'center', height: '25%' }}
      />
    ),
    inActiveList: ['Up & running within an hour', 'Zero setup costs'],
    activeList: [
      'We aim to be live within 48 hours of contact, if setup can be done remotely.',
      'If needed we can visit for on-site configuration, normally up and running in an hour.',
    ],
    active: 'Quick Setup',
  },
  {
    inActive: 'Get to Know Your Customers Better',
        icon: (
      <AiOutlineLineChart
        size='26px'
        color='#FDC00B'
        style={{ cursor: 'pointer', alignSelf: 'center', height: '25%' }}
      />
    ),
    inActiveList: [
      'Understand your customers preferences',
      'Increase margins with smart stock purchases',
    ],
    activeList: [
      'Viewing sales performance helps understand the nature of your customers, their preferences and how to better cater for them.',
      'Tracking the performance of products is vital in improving future stock orders and planning of operations.',
    ],
    active: 'Get to know your Customers better',
  },
  {
    inActive: 'On Site Training',
        icon: (
      <GiTeacher
        size='26px'
        color='#FDC00B'
        style={{ cursor: 'pointer', alignSelf: 'center', height: '25%' }}
      />
    ),
    inActiveList: ['Product demonstation', '24/7 assistance'],
    activeList: [
      'We provide free on site training which entails helping your staff understand how to maximise usage of DrinKing.',
      'We are available to contact 24/7 should you need assistance.',
    ],
    active: 'On Site Training',
  },
];

const Index = () => {
  const [isShown, setIsShown]: any = useState(null);
  return (
    <div className='whyChooseUs'>
      <h1>Why choose us?</h1>

      <div className='whyChooseUs__container'>
        {data.map((val: any, index) => (
          <button
            key={index}
            className='whyChooseUs__box'
            onMouseEnter={() => setIsShown(index)}
            onMouseLeave={() => setIsShown(null)}
          >
            {isShown === index ? (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'space-around',
                  minHeight: '90%',
                  width: '92%',
                }}
              >
                <h3
                  style={{ marginTop: '5%', marginBottom: 0, fontSize: '18px' }}
                >
                  {val.active}
                </h3>
                <ul style={{ listStyle: 'none', height: 'auto', padding: 0 }}>
                  {val.activeList.map((item: any, index: any) => (
                    <li key={index} style={{ padding: '1%', fontSize: '15px' }}>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ) : (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  height: '100%',
                  width: '92%',
                }}
              >
                {val.icon}
                <h3 style={{ textAlign: 'center', fontSize: '18px' }}>
                  {val.inActive}.
                </h3>
                <ul style={{ textAlign: 'left' }}>
                  {val.inActiveList.map((item: any, index: any) => (
                    <li
                      key={index}
                      style={{ paddingBottom: '2%', fontSize: '15px' }}
                    >
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Index;
